var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderShared.tsx";
import React from 'react';
import { createSvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderShared = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#00003D"
  }), /*#__PURE__*/_jsx("path", {
    opacity: "0.75",
    d: "M18 7.5H12L10.9425 6.4425C10.6575 6.1575 10.275 6 9.8775 6H6C5.175 6 4.5075 6.675 4.5075 7.5L4.5 16.5C4.5 17.325 5.175 18 6 18H18C18.825 18 19.5 17.325 19.5 16.5V9C19.5 8.175 18.825 7.5 18 7.5ZM14.25 9.75C15.075 9.75 15.75 10.425 15.75 11.25C15.75 12.075 15.075 12.75 14.25 12.75C13.425 12.75 12.75 12.075 12.75 11.25C12.75 10.425 13.425 9.75 14.25 9.75ZM17.25 15.75H11.25V15C11.25 14.0025 13.2525 13.5 14.25 13.5C15.2475 13.5 17.25 14.0025 17.25 15V15.75Z",
    fill: "#00003D"
  })]
}), 'FolderShared');